import { IErrorPersonAlreadyConnectedToManagerInfo } from "../../../interfaces/error/IAlreadyAttachPersonToManagerData";
import { isIOrganization } from "./isIOrganization";

export function isIErrorPersonAlreadyConnectedToManagerInfo(
  obj: any,
): obj is IErrorPersonAlreadyConnectedToManagerInfo {
  return (
    obj &&
    typeof obj === "object" &&
    typeof obj.email === "string" &&
    typeof obj.id === "number" &&
    typeof obj.image_path === "string" &&
    (typeof obj.inn === "string" || !obj.inn) &&
    typeof obj.is_banned === "boolean" &&
    typeof obj.is_enabled === "boolean" &&
    typeof obj.is_subscribed === "boolean" &&
    typeof obj.name === "string" &&
    (typeof obj.organization_id === "number" || !obj.organization_id) &&
    typeof obj.patronymic === "string" &&
    isIOrganization(obj.organization) &&
    (obj.phone_number === null || typeof obj.phone_number === "string") &&
    (obj.position === null || typeof obj.position === "string") &&
    (obj.role_id === null || typeof obj.role_id === "number") &&
    typeof obj.surname === "string" &&
    typeof obj.type === "string"
  );
}
